export default __webpack_public_path__ + "static/media/delete.0139d355.svg";